export default __webpack_public_path__ + "static/media/MetafightParticipate-min.a1b41abf.png";